import React from "react"
import styled from "styled-components"
import * as vars from "../style/vars"
import { below, clearFix, above } from "../style/functions"
import Link from "gatsby-link"
import shader from "shader"
import ReactHtmlParser from "react-html-parser"
import Video from "./video"

class Parra extends React.Component {


   render() {
      function scroll(e) {
         if (typeof window !== `undefined`) {
            let scrollDistance = window.pageYOffset
            window.scrollTo({
               top: scrollDistance + window.innerHeight,
               behavior: "smooth"
            })
         }
      }
      return (
         <Container className="parra-container">
            <div className="copy grid">
               <div className="inner">
                  <h1>{ReactHtmlParser(this.props.title)}</h1>
                  {this.props.videoUrl ? (
                     <Video url={this.props.videoUrl} poster="Watch the video →" popup />
                  ) : (
                     ""
                  )}

                  <div className="down" onClick={scroll} />
               </div>
            </div>
            <div className="img" id="scene">
				<InlineVideo  autoPlay loop  muted playsInline >
					<source src="https://s3-ap-southeast-2.amazonaws.com/cornwell-misc/yarra-bend/video-v2.mp4" type="video/mp4" />
					<source src="https://s3-ap-southeast-2.amazonaws.com/cornwell-misc/yarra-bend/video-v2.webm" type="video/webm" />
				</InlineVideo>
               <div data-depth="1" className="gradient" />
            </div>
         </Container>
      )
   }
}
const InlineVideo = styled.video `

`
const Container = styled.div`
   align-items: center;
   color: ${vars.colors.blank};
   background: ${vars.colors.body};
   display: flex;
   height: 84vmin;
	 min-height: 76rem;
   max-height: 125rem;

	${below.mobile`
		min-height: 59rem;
	`}
   h1 {
      max-width: 120rem;
			${below.giant`
         max-width: 110rem;
			br { display: none; }
		`};
   }
   p {
      padding-bottom: ${vars.padding.inner}rem;
   }
   .copy {
      padding-top: 12%;
      position: relative;
      z-index: 12;
      ${below.xl`
		padding-top: 6%;
		`};
		${below.mobile`
		z-index: 12;
		`};
   }

   .img {
      position: absolute;
      width: 100%;
      overflow: hidden;
      top: 0%;
      max-height: 150rem;
       img, .gradient, video {
         width: 100%;
         min-height: 145vh;
         object-fit: cover;
         max-width: none;

      }
			${above.mobile`
				img{
				display:none;
				}
			`};
      .gradient {
				position: absolute; 
				z-index: 10;
				top:0;
         background: radial-gradient(
            rgba(255, 255, 255, 0) 40%,
            rgba(63, 62, 62, 0.3) 60%
         );
         height: 120%;
				 ${below.mobile`
				 background: radial-gradient(
            rgba(255, 255, 255, 0) 40%,
            rgba(63, 62, 62, 0.1) 60%
         );
				 	`}
      }
   }

   .down {
      width: 3rem;
      height: 3rem;
      display: block;
      background-image: url("/svg/down-white.svg");
      background-repeat: no-repeat;
      background-size: 100%;
   }
`
const DownArrow = styled.div``

export default Parra



// WEBPACK FOOTER //
// ./src/components/parra1.js